import React, { createContext, forwardRef, useContext, useEffect, useRef, useState, } from "react";
import { PageTitle } from "../ui/ot"

const CrmContainerTitle1_1 = ({
    showComponent = ["PageTitle"],
    pageTitleProps = {
        pageTitleProps: {
            title: '建立文案',
            subTitle: '請選擇一種方式開始建立您的圖框樣式',
            color: "#134e4a",   // text-teal-800
            subTitlecolor: "#0d9488",   // text-teal-600
            bgcolor: { backgroundImage: "linear-gradient(to right, #f0fdfa, #f0fdf4)" },
        },
        needSecondTitle: true,
        secondTitle: "操作指引",
        secondTitleColor: "#134e4a",
        secondTitleBgcolor: "#134e4a",
        secondTitleBorderColor: "#134e4a",
        secondTitleIconBgcolor: "#134e4a",
        secondTitleDescriptionBgcolor: { backgroundImage: "linear-gradient(to right, #f0fdfa, #f0fdf4)" },
        secondTitleDescriptionColor: "#0f766e",   /* text-teal-700 */
        secondTitleDescription: "請先選擇一種建立方式，然後依照編號順序填寫必要資訊，進入文案編輯頁面。"
    }

}) => {

    return (
        <>
            {
                showComponent.includes("PageTitle") && (
                    <>
                        <PageTitle {...pageTitleProps?.pageTitleProps} />

                        {pageTitleProps?.needSecondTitle &&
                            <div className="mb-8 p-4 mx-4 mt-6  border rounded-md" style={{
                                backgroundImage: pageTitleProps?.secondTitleBgcolor,
                                border: `1px solid ${pageTitleProps?.secondTitleBorderColor}`
                            }}>
                                <h3 className="font-medium mb-2 flex items-center"
                                    style={{ color: pageTitleProps?.secondTitleDescriptionBgcolor || {} }}
                                >
                                    {/* <span className="text-white rounded-full w-6 h-6 flex items-center justify-center mr-2" style={{ backgroundColor: pageTitleProps?.secondTitleIconBgcolor } || {}}>
                                        i
                                    </span> */}
                                   { !!pageTitleProps?.secondTitle && <span style={{ color: pageTitleProps?.secondTitleColor } || {}}> {pageTitleProps?.secondTitle}</span>}
                                </h3>
                                {!!pageTitleProps?.secondTitleDescription && <p style={{ color: pageTitleProps?.secondTitleDescriptionColor } || {}}>{pageTitleProps?.secondTitleDescription}</p>}
                            </div >
                        }
                    </>
                )
            }
        </>
    )
}
export default CrmContainerTitle1_1